<template>

    <mini-map
        :carriers="carriers"
        :address = "address"
        large
    >
    </mini-map>
</template>

<script type="text/babel">
    import MiniMap from '../includes/MiniMap.vue';
    export default {
        name:'LargeMap',
        data:function(){
            return{
                carriers:[],
                address:{
                    address: '',
                    geolat: '',
                    geolat: '',
                    city: '',
                    state: '',
                    zip: '',
                    neighborhood: '',
                    formatted_address: ''
                }
            }
        },
        components:{
            MiniMap
        },
        created(){
            this.fetchCarriers();
        },
        methods:{
            fetchCarriers(){

                this.$send(this, 'carriers').then(r => {
                    this.carriers = r.carriers;
                });
            }
        }
    }
</script>


// WEBPACK FOOTER //
// Index.vue?43a7e9ae